import { Component, OnDestroy, OnInit } from '@angular/core';
import { RestService } from '../providers/rest.service';
import { AuthService } from '../auth/auth.service';
import { Router } from '@angular/router';
import { HelperProvider } from '../providers/helper.provider';
import { Subscription } from 'rxjs';
import { Page } from '../model/page';
import { GirisRequest } from '../model/giris-request';

@Component({
  selector: 'app-giris',
  templateUrl: './giris.component.html',
  styleUrls: ['./giris.component.css']
})
export class GirisComponent implements OnInit, OnDestroy {

  kullaniciAdi = '';
  sifre = '';

  redirecting = false;
  isLoading = false;
  subscriptions: Subscription[] = [];
  testUsers: string[] = [];

  constructor(private restService: RestService,
    private authService: AuthService,
    private router: Router,
    private helperProvider: HelperProvider) {
    // this.testUsers.push('Super Admin');
    // this.testUsers.push('Birim Sorumlusu');
    // this.testUsers.push('Tesis Müdürü');
    // this.testUsers.push('Talep Açan');
    // this.testUsers.push('Satın Alma Sorumlusu');
    // this.testUsers.push('Satın Alma Müdürü');
    // this.testUsers.push('Yönetici');
    // this.testUsers.push('Pazarlama');
    // this.testUsers.push('Ready Only');
  }

  ngOnInit(): void {
    this.helperProvider.currentPage$.next(Page.Giris);
    this.subscriptions.push(
      this.helperProvider.loading$.subscribe(isLoading => {
        if (isLoading != null) {
          this.isLoading = isLoading;
        }
      }));

    if (this.authService.isLoggedIn()) {
      this.redirecting = true;
      setTimeout(() => {
        this.router.navigate(['anasayfa']);
      }, 1000);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  login() {
    if (this.kullaniciAdi === '' || this.sifre === '') {
      alert('Lütfen kullanıcı adı ve şifrenizi giriniz!');
      return;
    }

    const request = new GirisRequest();
    request.kullaniciAdi = this.kullaniciAdi;
    request.sifre = this.sifre;
    debugger;
    this.restService.giris(request).subscribe(res => {
      if (res != null && res.token != null && res.kullanici) {
        if (res.kullanici.kullaniciGrupId !== 12) {
          const arr = [];
          for (const e of res.kullanici.kullaniciSubeler)
            arr.push(e.subeId);

          this.authService.login(res.kullanici, res.token, arr, false);
          this.router.navigate(['anasayfa']);
          return;
        }
        else {
          this.authService.login(res.kullanici, res.token, null, false);
          this.router.navigate(['tasimaci']);
        }
      }
    });
  }

  loginTestUser(user: string) {
    this.kullaniciAdi = user;
    this.sifre = '123123';
    this.login();
  }
}

